// src/features/interview/components/CameraView.jsx
import React from "react";
import ProctoringSystem from "./ProctoringSystem";

const CameraView = ({
  videoIncluded,
  proctoringVideoRef,
  onViolation,
  onCameraReady,
  isInterviewActive,
  interviewId,
  onStickyAlert,
  onFaceViolation,
  onMultipleFaceViolation,
  onProhibitedObjectViolation,
  onBodyPostureViolation,
  onGazeViolation,
  onFullscreenChange,
  onFullscreenExitViolation,
  onTabSwitchViolation,
  isRecording = false,
  className = "w-[600px] h-[360px]"
}) => {
  return (
    <div className={`flex flex-col items-center rounded-2xl glass-effect shadow-lg overflow-hidden relative ${className}`}
      style={isRecording ? { boxShadow: "0 0 0 3px rgba(79,102,255,0.7), 0 0 20px rgba(79,102,255,0.35)", outline: "2px solid #4F66FF" } : {}}
    >
      <ProctoringSystem
        isEnabled={videoIncluded}
        externalVideoRef={proctoringVideoRef}
        interviewId={interviewId}
        onViolation={onViolation}
        onCameraReady={onCameraReady}
        isInterviewActive={isInterviewActive}
        onStickyAlert={onStickyAlert}
        onFaceViolation={onFaceViolation}
        onMultipleFaceViolation={onMultipleFaceViolation}
        onProhibitedObjectViolation={onProhibitedObjectViolation}
        onBodyPostureViolation={onBodyPostureViolation}
        onGazeViolation={onGazeViolation}
        onFullscreenChange={onFullscreenChange}
        onFullscreenExitViolation={onFullscreenExitViolation}
        onTabSwitchViolation={onTabSwitchViolation}
      />
    </div>
  );
};

export default CameraView;
